import React from 'react'
import moment from 'moment'
import { COLORES } from '../../../../../../config/colores'
import OperacionesCamionesDescargados from '../components/OperacionesCamionesDescargados'
import TableValueAction from '../../../../../MuiTable/components/TableValueAction'
import InfoCpa from '../../../busquedaCpa/InfoCpa'

export const COLUMNS_CAMIONES_DESCARGADOS = [
  {
    name: 'datosCarga',
    label: 'Carta de porte',
    options: {
      filter: false,
      sort: true,
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      }),
      customBodyRender: (datosCarga) => {
        const numero = datosCarga && datosCarga.numero
        return (
          <>
            {numero
              ? <TableValueAction
                value={numero}
                title=' '
                content={<InfoCpa cpa={numero} />} />
              : null
            }
          </>
        )
      }
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      filterList: []
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    options: {
      filter: true,
      sort: true,
      filterList: [],
      filterType: 'checkbox',
      customBodyRender: (v) => (v.trim() === 'UNDEF' ? '-' : v)
    }
  },
  {
    name: 'fechaDeBruto',
    label: 'Fecha bruto',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (fecha) => fecha ? <>{moment(fecha).format('DD-MM HH:mm')}</> : null,
      display: false
    }
  },
  {
    name: 'fechaDeVolcado',
    label: 'Fecha volcado',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (fecha) => fecha ? <>{moment(fecha).format('DD-MM HH:mm')}</> : null,
      display: false
    }
  },
  {
    name: 'fDestare',
    label: 'Fecha destare',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'exportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (exportador) => exportador ? <>{exportador}</> : <></>
    }
  },
  {
    name: 'titular',
    label: 'Titular CPE',
    options: {
      filter: true,
      sort: true,
      display: false,
      filterType: 'multiselect'
    }
  },
  {
    name: 'remitenteComercial',
    label: 'Titular cupo',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'corredorVendedor',
    label: 'Corredor',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'vendedor',
    label: 'Entregador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'datosCarga',
    label: 'Chofer',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (datosCarga) => (datosCarga && datosCarga.chofer) ? <>{datosCarga.chofer}</> : <></>,
      display: false
    }
  },
  {
    name: 'datosCarga',
    label: 'Camión',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (datosCarga) => (datosCarga && datosCarga.camion) ? <>{datosCarga.camion}</> : <></>,
      display: false
    }
  },
  {
    name: 'pesoBruto',
    label: 'Peso bruto',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'pesoTara',
    label: 'Peso tara',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'pNeto',
    label: 'Peso neto',
    options: {
      filter: false,
      sort: true,
      total: true
    }
  },
  {
    name: 'pNetoOrigen',
    label: 'Peso neto origen',
    options: {
      filter: false,
      sort: true,
      total: true,
      display: false
    }
  },
  {
    name: 'humedad',
    label: 'Humedad',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'volcadoraCamiones',
    label: 'Volcadora camiones',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      display: false
    }
  },
  {
    name: 'calificacionCereal',
    label: 'Calificación cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'autodescargable',
    label: 'Autodescargable',
    options: {
      filter: true,
      sort: true,
      display: false,
      filterList: [],
      customBodyRender: autodescargable => {
        return (autodescargable) ? 'Si' : '  '
      }
    }
  },
  {
    name: 'datosCarga',
    label: ' ',
    options: {
      filter: false,
      sort: false,
      viewColumn: false,
      customBodyRender: (datos) => (!datos.ocultarOperaciones) ? <OperacionesCamionesDescargados numero={datos.numero} detalle={datos.detalle} /> : null
    }
  }
]
export const COLUMNS_CAMIONES_DESCARGADOS_TO_PRINT = [
  {
    name: 'exportador',
    label: 'Exportador',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'fDestare',
    label: 'Fecha destare',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'cartadeporte',
    label: 'Carta de porte',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'remitenteComercial',
    label: 'Titular de Cupo',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'corredorVendedor',
    label: 'Corredor',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'vendedor',
    label: 'Entregador',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'calificacionCereal',
    label: 'Calificación',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pNeto',
    label: 'Neto',
    width: 60,
    mantenerCase: true
  }
]
